export const JSON_CONTENT_TYPE_HEADER = { 'Content-Type': 'application/json' };